import React, { useRef, useState } from "react";
import { uploadCommunityDocument } from "../../services/documentService";

import {
  FaPaperPlane,
  FaPaperclip,
  FaImage,
  FaThumbtack,
  FaTimes,
  FaBullhorn,
  FaLightbulb,
  FaUsers,
  FaComments,
} from "react-icons/fa";


// =========================
// CATEGORIES
// =========================

const categories = [
  {
    value: "important",
    label: "Viktigt",
    icon: <FaBullhorn />,
    color: "bg-red-100 text-red-700 border-red-200",
  },

  {
    value: "tips",
    label: "Tips",
    icon: <FaLightbulb />,
    color: "bg-amber-100 text-amber-700 border-amber-200",
  },

  {
    value: "discussion",
    label: "Diskussion",
    icon: <FaComments />,
    color: "bg-sky-100 text-sky-700 border-sky-200",
  },

  {
    value: "social",
    label: "Socialt",
    icon: <FaUsers />,
    color: "bg-emerald-100 text-emerald-700 border-emerald-200",
  },
];


// =========================
// COMPONENT
// =========================

export default function PostComposer({
  onSubmit,
}) {


  const fileInput = useRef(null);


  const [title,setTitle] = useState("");
  const [text,setText] = useState("");

  const [category,setCategory] =
    useState("discussion");

  const [pinned,setPinned] =
    useState(false);

  const [attachment,setAttachment] =
    useState(null);



  // =========================
  // CREATE POST
  // =========================

  const handlePublish = async () => {
  if (!title.trim() && !text.trim()) {
    return;
  }

  let documentId = null;

  // Ladda upp vald fil först
  if (attachment) {
    try {
      const uploaded = await uploadCommunityDocument(attachment);
      documentId = uploaded.id;
    } catch (err) {
      console.error("Kunde inte ladda upp dokument", err);
      return;
    }
  }

  await onSubmit?.({
    title: title.trim() || "Nytt inlägg",
    text: text.trim(),
    category,
    pinned,
    documentId,
  });

  // Reset
  setTitle("");
  setText("");
  setPinned(false);
  setAttachment(null);
  setCategory("discussion");
};



    


  return (

<div className="
rounded-3xl
border
border-slate-200
bg-white
shadow-sm
overflow-hidden
">


{/* HEADER */}

<div className="
border-b
px-6
py-5
">


<h2 className="
text-lg
font-semibold
text-slate-900
">
Skapa nytt inlägg
</h2>


<p className="
text-sm
text-slate-500
mt-1
">
Dela information, frågor och idéer med kollegorna.
</p>


</div>





{/* BODY */}

<div className="
p-6
space-y-5
">


{/* TITLE */}

<input

value={title}

onChange={(e)=>
setTitle(e.target.value)
}

placeholder="Rubrik..."

className="
w-full
rounded-xl
border
border-slate-300
px-4
py-3
outline-none
focus:ring-2
focus:ring-slate-300
"

/>





{/* TEXT */}

<textarea

rows={5}

value={text}

onChange={(e)=>
setText(e.target.value)
}

placeholder="
Skriv ett meddelande till teamet...
"

className="
w-full
resize-none
rounded-xl
border
border-slate-300
px-4
py-3
outline-none
focus:ring-2
focus:ring-slate-300
"

/>






{/* CATEGORY */}

<div>


<div className="
text-sm
font-medium
text-slate-600
mb-3
">
Kategori
</div>



<div className="
flex
flex-wrap
gap-2
">


{
categories.map(cat=>(

<button

key={cat.value}

type="button"

onClick={()=>
setCategory(cat.value)
}

className={`
flex
items-center
gap-2
rounded-full
border
px-4
py-2
text-sm
transition

${
category===cat.value

?
cat.color

:
"bg-slate-50 text-slate-500 border-slate-200"
}

`}

>

{cat.icon}

{cat.label}


</button>


))
}


</div>


</div>







{/* ATTACHMENT */}

{
attachment && (

<div className="
flex
items-center
justify-between
rounded-xl
bg-slate-100
px-4
py-3
text-sm
">

<div className="
flex
items-center
gap-2
">

<FaPaperclip/>

{attachment.name}

</div>



<button

onClick={()=>
setAttachment(null)
}

className="
text-slate-500
hover:text-red-500
"

>

<FaTimes/>

</button>


</div>

)

}



</div>








{/* FOOTER */}

<div className="
border-t
bg-slate-50
px-6
py-4
flex
items-center
justify-between
">





<div className="
flex
gap-3
">


{/* FILE */}

<button

onClick={()=>
fileInput.current.click()
}

className="
rounded-xl
border
bg-white
px-3
py-2
hover:bg-slate-100
"

>

<FaPaperclip/>

</button>




{/* IMAGE */}

<button

onClick={()=>
fileInput.current.click()
}

className="
rounded-xl
border
bg-white
px-3
py-2
hover:bg-slate-100
"

>

<FaImage/>

</button>





{/* PIN */}

<button

onClick={()=>
setPinned(!pinned)
}

className={`
rounded-xl
border
px-3
py-2

${
pinned
?
"bg-amber-100 text-amber-700"
:
"bg-white text-slate-600"
}

`}

>

<FaThumbtack/>

</button>



<input

ref={fileInput}

type="file"

accept="
image/*,
application/pdf,
.doc,
.docx,
.xls,
.xlsx
"

hidden

onChange={(e)=>{

const file = e.target.files?.[0];

if(file){
  setAttachment(file);
}

}}

/>


</div>








{/* SEND */}

<button

onClick={handlePublish}

className="
flex
items-center
gap-2
rounded-xl
bg-slate-900
px-5
py-3
text-white
hover:bg-slate-800
"

>

<FaPaperPlane/>

Publicera


</button>





</div>



</div>

  );

}